/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React, { Component } from "react";
import { connect } from "react-redux";

interface Props {
  history: Object;
  isAuthenticated: boolean;
}

export default function RequireAuth(ComposedComponent, allowedRoles) {
  // const content = ''

  class Authentication extends Component<Props> {
    componentDidMount() {
      console.log("THIS PROPS", this.props);
      if (!this.props.isAuthenticated) {
        this.props.history.push("/");
      } else if (this.props.isAuthenticated) {
        if (!allowedRoles?.includes(this.props.role)) {
          this.props.history.push("/dashboard");
        }
      }
    }

    componentDidUpdate(nextProps) {
      if (!nextProps.isAuthenticated) {
        this.props.history.push("/");
      }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      role: state.auth?.user?.user.role,
      test: state,
    };
  }

  return connect(mapStateToProps)(Authentication);
}
